import HeroVideoDialog from '@/shared/ui/hero-video-dialog.tsx';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/shared/ui/tabs"

const Testimonials = () => {

  return (
    <div className="relative w-full flex flex-col items-center justify-center xl:h-[90vh] z-50">
      <div className="text-center mb-16 xl:mb-24 space-y-8 xl:space-y-14">
        <h2 className="text-3xl xl:text-5xl font-montserrat font-bold text-[#390088] mb-4">How our partners feel about siAi</h2>
        <Tabs defaultValue="demo">
          <TabsList className='rounded-full my-4'>
            <TabsTrigger value="demo" className='font-montserrat tracking-wide rounded-full data-[state=active]:bg-purple-500 data-[state=active]:text-white px-4 text-lg'>Watch Demo</TabsTrigger>
            <TabsTrigger value="testimonial" className='font-montserrat tracking-wide rounded-full data-[state=active]:bg-purple-500 data-[state=active]:text-white px-4 text-lg'>Testimonials</TabsTrigger>
          </TabsList>
          <TabsContent value="demo">

            <div className='md:w-[55rem] px-5 xl:px-10 mx-auto'>
              <HeroVideoDialog
                className="block dark:hidden"
                animationStyle="from-center"
                videoSrc="https://www.loom.com/embed/d9c6c6e5acb444fa9813b32b479824a0"
                thumbnailSrc='https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9nYEqaMjFXeoEuz1R0LN8a2SkPDg9MshcvKfx'
              />
            </div>
          </TabsContent>
          <TabsContent value="testimonial">
            <div className='md:w-[55rem] px-5 xl:px-10 mx-auto'>
              <HeroVideoDialog
                className="block dark:hidden"
                animationStyle="from-center"
                videoSrc="https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9nfO2v1jFXeoEuz1R0LN8a2SkPDg9MshcvKfx"
                thumbnailSrc='https://86v8u6agau.ufs.sh/f/A17KOoeuO4h9C5Q4mPdZeKrO16wj9s3S0dhQR2tA58Z4FipT'
              />
            </div>
          </TabsContent>
        </Tabs>
      </div>

    </div>
  )
}

export default Testimonials;
